
import { useMemo } from 'react';
import { Device, Consumer } from '../types';
import { 
  getEnergyDevices, 
  getGasDevices, 
  getWaterDevices, 
  getConsumers 
} from '../sampleData';

/**
 * Hook for managing device map data
 */
export const useMapData = (deviceType: 'energy' | 'gas' | 'water' = 'energy') => {
  // Get devices based on the deviceType
  const allDevices = useMemo(() => {
    switch (deviceType) {
      case 'gas':
        return getGasDevices();
      case 'water':
        return getWaterDevices();
      case 'energy':
      default:
        return getEnergyDevices();
    }
  }, [deviceType]);
  
  // Get consumers
  const consumers = useMemo(() => getConsumers(), []);
  
  // Calculate default map center based on device type
  const getDefaultCenter = (): [number, number] => {
    switch (deviceType) {
      case 'gas':
        return [37.5, -98.0]; // Central US for gas
      case 'water':
        return [34.0, -111.0]; // Western US for water
      case 'energy':
      default:
        return [40.0, -95.0]; // Eastern US for energy
    }
  };
  
  const defaultCenter = getDefaultCenter();
  const zoom = 4;

  return {
    allDevices,
    consumers,
    defaultCenter,
    zoom
  };
};
